/** @format */

import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
      labels: {
        color: "#2C3E50",
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    datalabels: {
      formatter: (value) => `${value}%`,
      color: "#fff",
      backgroundColor: "rgba(44, 62, 80, 0.8)",
      borderRadius: 4,
      padding: 6,
      font: {
        weight: "bold",
        size: 14,
      },
    },
  },
};

const modernColors = [
  "#06B6D4",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
  "#4F46E5",
];

const hoverColors = [
  "#0891B2",
  "#059669",
  "#D97706",
  "#DC2626",
  "#7C3AED",
  "#4338CA",
];

const PieChart1 = ({ d1, d2, d3, f1, f2, f3 }) => {
  const data = {
    labels: [
      `O’zbekiston - ${d1} m³/s`,
      `Tojikiston - ${d2} m³/s`,
      `Qirg’iziston - ${d3} m³/s`,
    ],
    datasets: [
      {
        label: "Suv taqsimoti",
        data: [f1, f2, f3],
        backgroundColor: modernColors,
        hoverBackgroundColor: hoverColors,
        borderColor: "#ECF0F1",
        borderWidth: 2,
        hoverBorderColor: "#BDC3C7",
      },
    ],
  };

  return (
    <div
      className='pie-box'
      style={{
        height: "450px",
      }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart1;
